export const initialState = {
    is_loading: true,
    admin_info: [],
    admin_password: ""
}